import { render, staticRenderFns } from "./ArticleAudit.vue?vue&type=template&id=156abfd4&scoped=true"
import script from "./ArticleAudit.vue?vue&type=script&lang=js"
export * from "./ArticleAudit.vue?vue&type=script&lang=js"
import style0 from "./ArticleAudit.vue?vue&type=style&index=0&id=156abfd4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156abfd4",
  null
  
)

export default component.exports